(function () {
  var FS_THRESHOLD = 7500; // pence — £75.00

  function formatMoney(pence) {
    return '\xA3' + (pence / 100).toFixed(2);
  }

  function updateBars(totalCents) {
    var pct = Math.min(100, Math.round((totalCents / FS_THRESHOLD) * 100));
    var remaining = Math.max(0, FS_THRESHOLD - totalCents);

    document.querySelectorAll('.fs-bar').forEach(function (bar) {
      var fill = bar.querySelector('.fs-bar__fill');
      var msg  = bar.querySelector('.fs-bar__msg');
      if (!fill || !msg) return;

      if (totalCents >= FS_THRESHOLD) {
        msg.className = 'fs-bar__msg fs-bar__msg--unlocked';
        msg.innerHTML = 'You’ve unlocked free shipping! 🎉';
      } else {
        msg.className = 'fs-bar__msg';
        msg.innerHTML = 'You’re <strong>' + formatMoney(remaining) + '</strong> away from free shipping';
      }

      fill.dataset.fsTarget = String(pct);
      fill.style.display = 'block';
      fill.style.backgroundColor = '#580e0c';
      fill.style.height = '100%';
      fill.style.width = pct + '%';
    });
  }

  function refreshFromCart() {
    fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBars(cart.total_price); })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      requestAnimationFrame(refreshFromCart);
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-notification').then(function () {
      var proto = customElements.get('cart-notification').prototype;
      var originalOpen = proto.open;
      proto.open = function () {
        var result = originalOpen.apply(this, arguments);
        requestAnimationFrame(refreshFromCart);
        return result;
      };
    });
  }
})();
